export default __webpack_public_path__ + "static/media/AGO_maps_lower-level-concourse.8bc857d7.png";